<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> Volver
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              Crear nueva condición
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  Nombre <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombre" v-model="form.nombre" required
                  placeholder="Nombre"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="nombreIngles">
                <template v-slot:label>
                  Nombre (inglés)
                </template>
                <b-form-input id="nombreIngles" v-model="form.nombreIngles"
                  placeholder="Nombre (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="codigo">
                <template v-slot:label>
                  Código
                </template>
                <b-form-input id="codigo" v-model="form.codigo"
                  placeholder="Código"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group label-for="observacion">
                <template v-slot:label>
                  Observación
                </template>
                <b-form-textarea id="observacion" v-model="form.observacion" rows="3"
                  placeholder="Observación"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            Guardar
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import condicionService from '@/api/condicionService';
import Swal from 'sweetalert2';

export default {
  name: 'CondicionCrear',
  data() {
    return {
      form: {
        nombre: '',
        nombreIngles: '',
        codigo: '',
        observacion: '',
      },
    };
  },
  methods: {
    submitForm() {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Revisa los datos ingresados.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Crear condición',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">Creando...</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await condicionService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
            return;
          }

          Swal.fire({
            title: 'Creado correctamente',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          const data = response.data;
          const newId = (data && data.id) ? data.id : null;

          if (newId) {
            this.$router.push({ name: 'condicion-detalle', params: { id: newId } });
          } else {
            this.$router.push({ name: 'condiciones' });
          }
        } catch (error) {
          const raw = (error && error.response) ? error.response.data : error;
          try { console.error('Create condicion error payload:', raw); } catch (e) { /* noop */ }

          let status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }

          let msg = 'Error';
          if (typeof raw === 'string') {
            msg = raw;
          } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
            msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
          } else if (error && error.message) {
            msg = error.message;
          } else {
            try { msg = JSON.stringify(raw, null, 2); } catch (e) { msg = 'Error'; }
          }

          const title = (status === 409) ? 'La condición ya existe' :
                        (status === 400) ? 'Datos inválidos' : 'Oops...';
          const icon  = (status === 409 || status === 400) ? 'warning' : 'error';

          Swal.fire({
            icon: icon,
            title: title,
            html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">' + msg + '</pre>',
          });
        }
      });
    },
  },
};
</script>
